import { Link } from "react-router-dom";

// Paleta: aqua #00b4c8, rosa pastel #f9b8c8, morado pastel #c9b8f0, amarillo pastel #fde68a

export default function Footer() {
  return (
    <footer className="bg-[#fdf6ff]">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/0ec3dba52746e06034f9e14a4c92941b.jpeg"
              alt="San7o Pecado"
              className="h-12 w-12 rounded-full object-cover"
            />
            <span
              className="font-bold text-lg text-[#2d1a0e]"
              style={{ fontFamily: "Singo" }}
            >
              SAN7O PECADO
            </span>
          </div>
          <p className="text-sm text-[#6b5b6e] leading-relaxed">
            En San7o Pecado Postrerías, no vendemos pasteles, te consentimos, te acompañamos y celebramos los mejores momentos de tu vida.
          </p>
          <div className="flex items-center gap-3 mt-2">
            <a
              href="https://www.instagram.com/san7opecado/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-[#f9b8c8]/30 text-[#d4607a] hover:bg-[#f9b8c8] hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="https://www.facebook.com/san7opecado/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-[#c9b8f0]/30 text-[#7c5cbf] hover:bg-[#c9b8f0] hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-facebook-line text-lg"></i>
            </a>
            <a
              href="https://www.tiktok.com/@san7o.pecado"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-[#fde68a]/40 text-[#b08000] hover:bg-[#fde68a] hover:text-[#2d1a0e] transition-colors cursor-pointer"
            >
              <i className="ri-tiktok-line text-lg"></i>
            </a>
            <a
              href="https://wa.me/5217291317070"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-[#00b4c8]/20 text-[#00b4c8] hover:bg-[#00b4c8] hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-semibold text-[#2d1a0e] mb-4 text-sm uppercase tracking-wider">
            <a href="#links">Navegación</a>
          </h4>
          <ul className="flex flex-col gap-2">
            {[
              { label: "Inicio", path: "/" },
              { label: "Menú", path: "/menu" },
              { label: "Dónde Pecar", path: "/contacto" },
              { label: "Nosotros", path: "/nosotros" },
              { label: "Causas Sociales", path: "/causas" },
              { label: "Blog", path: "/blog" },
            ].map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-sm text-[#6b5b6e] hover:text-[#00b4c8] transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="font-semibold text-[#2d1a0e] mb-4 text-sm uppercase tracking-wider">
            <a href="#contacto">Contacto</a>
          </h4>
          <ul className="flex flex-col gap-3">
            <li className="flex items-start gap-2 text-sm text-[#6b5b6e]">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-map-pin-line text-[#d4607a]"></i>
              </div>
              <span>Av Tecnológico 715, San Salvador Tizatlali, Metepec, México, 52172</span>
            </li>
            <li className="flex items-center gap-2 text-sm text-[#6b5b6e]">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-[#00b4c8]"></i>
              </div>
              <a href="tel:+5217291317070" className="hover:text-[#00b4c8] transition-colors">
                +52 1 729 131 7070
              </a>
            </li>
            <li className="flex items-center gap-2 text-sm text-[#6b5b6e]">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-[#7c5cbf]"></i>
              </div>
              <a href="mailto:san7opecado@gmail.com" className="hover:text-[#7c5cbf] transition-colors">
                san7opecado@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-2 text-sm text-[#6b5b6e]">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-time-line text-[#d4607a]"></i>
              </div>
              <div className="flex flex-col gap-0.5">
                <span>Lun - Sáb: 8:00 - 21:00</span>
                <span>Dom: 9:00 - 20:00</span>
              </div>
            </li>
          </ul>
        </div>

        {/* Santas Huellitas */}
        <div>
          <h4 className="font-semibold text-[#2d1a0e] mb-4 text-sm uppercase tracking-wider">
            <a href="#causas">Causa Social</a>
          </h4>
          <a
            href="https://www.instagram.com/san7as.huellitas/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 group cursor-pointer mb-6"
          >
            <img
              src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/8db8aa41c94b113edaa0ef92042e954f.png"
              alt="San7as Huellitas"
              className="w-12 h-12 rounded-full object-cover shrink-0"
            />
            <div>
              <p className="font-bold text-[#00b4c8] text-sm group-hover:underline">San7as Huellitas</p>
              <p className="text-xs text-[#6b5b6e] leading-relaxed mt-0.5">Parte de nuestras ventas apoya el rescate y adopción de perritos.</p>
            </div>
          </a>
          <p className="text-xs font-semibold text-[#6b5b6e] uppercase tracking-widest mb-3">Orgullosamente</p>
          <div className="flex items-center gap-4">
            <img
              src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/e627ad8c3197856db737d09cce76a13e.png"
              alt="Hecho en México"
              className="h-12 w-auto object-contain"
            />
            <img
              src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/8bf1506eab79be5aec1867877293a888.png"
              alt="Asociación de Franquicias"
              className="h-12 w-auto object-contain"
            />
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#f0e8f5] border-t border-[#c9b8f0]/40 py-5 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#6b5b6e]">
            © 2026 San7o Pecado. Todos los derechos reservados. Hecho con amor en México.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-[#6b5b6e] cursor-pointer hover:text-[#7c5cbf] transition-colors">
              Aviso de Privacidad
            </span>
            <span className="text-xs text-[#6b5b6e] cursor-pointer hover:text-[#7c5cbf] transition-colors">
              Términos y Condiciones
            </span>
            <Link
              to="/admin/login"
              className="w-7 h-7 flex items-center justify-center rounded-full bg-[#c9b8f0]/40 text-[#7c5cbf] hover:bg-[#d4607a] hover:text-white transition-colors cursor-pointer"
              title="Acceso administrador"
            >
              <i className="ri-settings-3-line text-sm"></i>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
